import { useSwapProductAuthenticationMutation } from "@biggeo/bg-server-lib/studio";
import {
    AuthenticatedUser,
    ProductPermission,
    useFetchAllProductsQuery,
} from "@biggeo/bg-server-lib/studio";
import { Success, isSuccess } from "@vividtheory/remotedata";
import { useDispatch } from "react-redux";

import { PortalMenu } from "../../home/views/PortalMenu";
import { useErrorToast } from "../../toaster/containers/redux/hooks";
import { userActions } from "../../user/redux/model";
import { unwrapMaybe } from "../utils/helpers";

export const PortalMenuContainer = ({
    user,
}: {
    readonly user: AuthenticatedUser;
}) => {
    const dispatch = useDispatch();
    const errorToast = useErrorToast();

    const {
        executeMutation: swapProductAuthentication,
        mutationReturn: [_j, { loading: swapProductAuthLoading }],
    } = useSwapProductAuthenticationMutation();

    const swapProductAuth = (productId: string) => {
        swapProductAuthentication({
            variables: {
                productId: productId,
            },
            onCompleted: (data) => {
                dispatch(
                    userActions.setUserRemoteData(
                        new Success({
                            ...data.swapProductAuthentication,
                        })
                    )
                );
            },
            onError: () => {
                errorToast("An error occurred while switching products.");
            },
        });
    };

    const { remote } = useFetchAllProductsQuery({
        variables: {
            input: {
                fkOrganizationId: user.organization?.id,
                productEnums: [ProductPermission.datascapeAi],
            },
        },
    });

    return (
        <PortalMenu
            user={user}
            products={isSuccess(remote) ? remote.data.fetchAllProducts : []}
            swapProductAuth={swapProductAuth}
            swapProductLoading={swapProductAuthLoading}
            selectedProduct={unwrapMaybe(user.product)}
        />
    );
};
